import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

// TODO(intools-access): replace placeholder ids with real backend-provisioned 32-hex (T002).
export const IntoolsAccessUserRBAC = {
  pageID: '4609f2c27e27333c377315cd3620f041',
  elementID: {
    ViewUser: 'b1e5871f5cadffac16402a540e5d7613',
    EditViewDetailUserButton: 'aeda0c3e29aa944b7b507c6663411325',
    // AddUserButton: 'ebfe3091a52695f88b3b933d9450a6d0',
    SaveEditUserButton: '11f392b5d76bc5d5bc6a50b84a649dc9',
  },
} as const

export const useRBACIntoolsAccessUserPage = createUseRBAC(IntoolsAccessUserRBAC.elementID)

export type UseRBACIntoolsAccessUserPageType = ReturnType<typeof useRBACIntoolsAccessUserPage>
